export default {
  title: '會員等級特權',
  addLevel: '新增會員等級',
  levelName: '等級名稱',
  levelNamePlaceholder: '請輸入等級名稱',
  addI18n: '新增多語言',
  addTitle: '新增會員等級',
  editTitle: '編輯會員等級',
  deleteConfirm: '刪除後不可恢復，確定要刪除嗎？',
  columns: {
    level: '等級',
    name: '等級名稱',
    growth: '所需成長值',
    memberCount: '會員數量',
    sort: '排序',
    status: '狀態',
    benefitCount: '會員數量',
  },
  form: {
    baseInfo: '基礎信息',
    levelName: '會員等級名稱',
    levelNamePlaceholder: '請輸入等級名稱',
    levelNameRequired: '請輸入等級名稱',
    namePlaceholder: '請輸入等級名稱',
    growthValue: '會員成長值',
    growthValuePlaceholder: '請輸入成長值',
    growthValueRequired: '請輸入成長值',
    birthdayGift: '生日禮包',
    birthdayGiftDesc: '用戶生日時，系統自動贈送積分奖励',
    sendPoints: '送積分',
    pointsPlaceholder: '請輸入',
    pointsUnit: '積分',
    birthdayPointsRequired: '請輸入贈送積分數',
    discountPrivilege: '折扣特權',
    discountPrivilegeDesc: '用戶使用積分兌換禮品時可享受折扣',
    pointsExchangeGift: '積分兌換禮品',
    discountPlaceholder: '請輸入',
    discountUnit: '折',
    discountRequired: '請輸入折扣值',
  },
  i18nEditTitle: '多語言編輯',
  i18nModal: {
    title: '多語言（等級名稱）',
    nameSuffix: '等級名稱',
  },
};
